module.exports = __webpack_public_path__ + "img/venomverse.90c2484a.svg";